import React from 'react';
import { Menu, Typography, Col, Row } from 'antd';
import { MailOutlined, DownloadOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { TemplateDocumentButton } from '../../../../components/TemplateDocumentButton/TemplateDocumentButton';

const { Text } = Typography;

export const ExplanatoryDocumentMenu = ({
  pensioner,
  setIsEmailModalOpen,
  setTemplateType,
  setDocumentType
}) => {
  const { t } = useTranslation();

  return (
    <Menu>
      <Menu.Item
        key={pensioner._id}
        onClick={() => {
          setIsEmailModalOpen(true);
          setTemplateType('SEND_EXPLANATORY_DOCUMENT');
          setDocumentType('PENSIONER_EXPLANATORY_WITHOUT_NAME');
        }}
      >
        <Row gutter={10}>
          <Col>
            <MailOutlined />
          </Col>
          <Col>
            <Text>{t('pensioners.show.buttons.send_mail')}</Text>
          </Col>
        </Row>
      </Menu.Item>

      <TemplateDocumentButton
        parameters={[
          {
            collection: 'Pensioner',
            documentId: pensioner._id
          }
        ]}
        use_case="PENSIONER_EXPLANATORY_DOCUMENT"
        icon={<DownloadOutlined />}
        withIcon
        button_text="pensioners.show.buttons.dl_doc"
        fromMenu
        downloadName={t(
          'template-documents.form.PENSIONER_EXPLANATORY_DOCUMENT_FILENAME',
          {
            pensioner_name: `${pensioner.last_name} ${pensioner.first_name}`
          }
        )}
        key={`dl${pensioner._id}`}
      />
    </Menu>
  );
};

ExplanatoryDocumentMenu.propTypes = {
  pensioner: PropTypes.shape({
    _id: PropTypes.string,
    type: PropTypes.string,
    number: PropTypes.number,
    last_name: PropTypes.string,
    first_name: PropTypes.string
  }),
  setIsEmailModalOpen: PropTypes.func,
  setTemplateType: PropTypes.func,
  setDocumentType: PropTypes.func
};

ExplanatoryDocumentMenu.defaultProps = {
  pensioner: {},
  setIsEmailModalOpen: () => {},
  setTemplateType: () => {},
  setDocumentType: () => {}
};
